export enum ContactInfoType {
  workEmail = 1,
  workPhone = 2,
  personalEmail = 3,
  mobilePhone = 4
}
